import { SB_LANGUAGES } from '~/modules/storyblok/constants';

export default function resolveSBLanguage(lang: string): 'default' | string {
  return lang in SB_LANGUAGES ? lang : 'default';
}
